// Fechas civiles en Lima: evita desplazar un día al interpretar YYYY-MM-DD.
const dayNumber = value => {
  const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return null;
  const [, y, m, d] = match.map(Number);
  const date = new Date(Date.UTC(y, m - 1, d));
  return date.getUTCFullYear() === y && date.getUTCMonth() === m - 1 && date.getUTCDate() === d ? date.getTime() / 86400000 : null;
};
export const todayInLima = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Lima', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
export const formatMembershipDate = value => {
  if (dayNumber(value) === null) return '';
  const [y, m, d] = String(value).slice(0, 10).split('-');
  return d + '/' + m + '/' + y;
};
export const membershipDisplay = (data = {}, today = todayInLima()) => {
  const end = dayNumber(data.fechaFin || data.fecha_fin || data.fechaVencimiento);
  const start = dayNumber(data.fechaInicio || data.fecha_inicio);
  const current = dayNumber(today);
  const days = end !== null && current !== null ? Math.max(0, end - current) : null;
  const duration = start !== null && end !== null && end > start ? end - start : null;
  return { days, date: formatMembershipDate(data.fechaFin || data.fecha_fin || data.fechaVencimiento), progress: days !== null && duration ? Math.min(100, Math.max(0, days / duration * 100)) : null };
};
// Último día de los precios de lanzamiento. Es la única fecha de la promoción:
// el modal de planes la usa para el titular y para su cuenta atrás, así que
// cambiándola aquí se mueve todo a la vez.
export const PROMO_FIN_ISO = '2026-09-20';

export const launchOffer = (today = todayInLima()) => {
  const days = dayNumber(PROMO_FIN_ISO) - dayNumber(today);
  return { active: days >= 0, days: Math.max(0, days) };
};
